import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { UserStorage } from "./UserContext";
import ProtectedRoute from "./protectedRoutes/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";

import Footer from "./Components/Footer";
import Header from "./Components/Header";
import PublicLayout from "./Components/PublicLayout";

import Home from "./Pages/Home/Home";
import Sobre from "./Pages/sobre/sobre";
import Equipe from "./Pages/equipe/equipe";
import Contato from "./Pages/contato/contato";
import Login from "./Pages/login/Login";
import WebPush from "./Pages/webpush/WebPush";
import Dashboards from "./Pages/dashboards/Dashboards";
import SitemapConcorrentes from "./Pages/dashboards/7SitemapConcorrentes";
import DahsPortais from "./Pages/dashboards/1DashPortais";
import IndicadoresBlog from "./Pages/dashboards/2IndicadoresBlog";
import IndicadoresSeo from "./Pages/dashboards/3IndicadoresSeo";
import DashCms from "./Pages/dashboards/4DashCms";
import ReportMensalPortais from "./Pages/dashboards/5ReportMensalPortais";
import ReportMensalSeo from "./Pages/dashboards/6ReportMensalSeo";

import LinksQuebrados from "./Pages/dashboards/8LinksQuebrados";
// import Sherlock from "./Pages/dashboards/9Sherlock";
import Inmetro from "./Pages/dashboards/910Inmetro";
import Galvao from "./Pages/dashboards/911Galvao";
import VitrineMensuracao from "./Pages/dashboards/912VitrineMensuracao";
import Menusca from "./Pages/dashboards/913Menusca";
import BoltSnt from "./Pages/dashboards/914BoltSnt";
import PipefyOpec from "./Pages/dashboards/915PipefyOpec";
import Pipefy from "./Pages/dashboards/916Pipefy";
import VitrineBasesManuais from "./Pages/dashboards/917VitrineBasesManuais";
import Componentes from "./Pages/dashboards/918Componentes";
import Onboarding from "./Pages/dashboards/919Onboarding";
import OfertaContextual from "./Pages/ofertaContextual/OfertaContextual";
import OfertaContextualRegistros from "./Pages/ofertaContextual/OfertaContextualRegistros";
import LoginChangePassword from './Components/ChangePasswordDialog/ChangePasswordDialog'

import Sherlock from "./Pages/Sherlock";

import "./App.css";
import Menu from "./Components/Menu";
import VitrineTelasComprovantes from "./Pages/vitrine/VitrineTelasComprovantes";
import WebPushRegister from "./Pages/webpush/WebPushRegister";
import WebPushExclusion from "./Pages/webpush/WebPushExclusion";
import WebPushAgendamentos from "./Pages/webpush/WebPushAgendamentos";
import WebPushAgendamentos2 from "./Pages/webpush/WebPushAgendamentos2";
import AdminMenu from "./Pages/admin/admin";
import PsicologiaInfantil from "./Pages/psicologiaInfantil/psicologiaInfantil";
import Pediatra from "./Pages/pediatra/pediatra";
import Nutricionista from "./Pages/nutricionista/nutricionista";
import Psicopedagogia from "./Pages/psicopedagogia/psicopedagogia";
import Fisioterapia from "./Pages/fisioterapia/fisioterapia";
import TranstornosAnsiedadeInfantil from "./Pages/transtornosansiedadeinfantil/transtornosansiedadeinfantil";
import Tdah from "./Pages/tdah/tdah";
import Avaliacaoneuropsicologica from "./Pages/avaliacaoneuropsicologica/avaliacaoneuropsicologica";
import MetodoClinicaInteligente from "./Pages/MetodoClinicaInteligente/MetodoClinicaInteligente";

const App = () => {
  const [passwordDialog, setPasswordDialog] = React.useState(false)
  function handleCloseDialog() {
    setPasswordDialog(false)
  }
  return (
    <BrowserRouter>
      <UserStorage>
        <Routes>
          {/* Rotas Públicas com Layout Público */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/psicologia-infantil" element={<PsicologiaInfantil />} />
            <Route path="/pediatra" element={<Pediatra />} />
            <Route path="/nutricionista" element={<Nutricionista />} />
            <Route path="/fisioterapia" element={<Fisioterapia />} />
            <Route path="/avaliacao-neuropsicologica" element={<Avaliacaoneuropsicologica />} />
            <Route path="/psicopedagogia" element={<Psicopedagogia />} />
            <Route path="/transtornos-ansiedade-infantil" element={<TranstornosAnsiedadeInfantil />} />
            <Route path="/transtorno-deficit-atencao-hiperatividade-tdah" element={<Tdah />} />
            <Route path="/login" element={<Login />} />
          </Route>

          {/* Landing Pages Standalone */}
          <Route path="/metodo-clinica-inteligente" element={<MetodoClinicaInteligente />} />

          {/* Rotas Protegidas (Dashboard/Admin) */}
          <Route
            path="*"
            element={
              <ProtectedRoute to={"/login"}>
                <div className="container-main">
                  <Menu />
                  <div className="container-routes">
                    <Header />
                    <Routes>
                      <Route path="/vitrine-telas-comprovante" element={<VitrineTelasComprovantes />} />
                      <Route path="/oferta-contextual" element={<OfertaContextual />} />
                      <Route path="/oferta-contextual-registros" element={<OfertaContextualRegistros />} />
                      <Route path="/web-push" element={<WebPush />} />
                      <Route path="/dashboards" element={<Dashboards />} />
                      <Route path="/dashboards/dash-portais" element={<DahsPortais />} />
                      <Route path="/dashboards/indicadores-blog" element={<IndicadoresBlog />} />
                      <Route path="/dashboards/indicadores-seo" element={<IndicadoresSeo />} />
                      <Route path="/dashboards/dash-cms" element={<DashCms />} />
                      <Route path="/dashboards/report-mensal-portais" element={<ReportMensalPortais />} />
                      <Route path="/dashboards/report-mensal-seo" element={<ReportMensalSeo />} />
                      <Route path="/dashboards/sitemap-concorrentes" element={<SitemapConcorrentes />} />
                      <Route path="/dashboards/links-quebrados" element={<LinksQuebrados />} />
                      <Route path="/sherlock" element={<Sherlock />} />
                      <Route path="/dashboards/inmetro" element={<Inmetro />} />
                      <Route path="/dashboards/galvao-bueno" element={<Galvao />} />
                      <Route path="/dashboards/vitrine-mensuracao" element={<VitrineMensuracao />} />
                      <Route path="/dashboards/menusca" element={<Menusca />} />
                      <Route path="/dashboards/bolt-snt" element={<BoltSnt />} />
                      <Route path="/dashboards/pipefy-opec" element={<PipefyOpec />} />
                      <Route path="/dashboards/pipefy-cms" element={<Pipefy />} />
                      <Route path="/dashboards/vitrine-bases-manuais" element={<VitrineBasesManuais />} />
                      <Route path="/dashboards/componentes" element={<Componentes />} />
                      <Route path="/dashboards/onboarding" element={<Onboarding />} />
                      <Route path="/web-push-registros" element={<WebPushRegister />} />
                      <Route path="/rotina-exclusao" element={<WebPushExclusion />} />
                      <Route path="/web-push-agendamentos" element={<WebPushAgendamentos />} />
                      <Route path="/web-push-agendamentos-2" element={<WebPushAgendamentos2 />} />
                      <Route path="/admin-menu" element={<AdminMenu />} />
                    </Routes>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
        <LoginChangePassword onRequestClose={handleCloseDialog} />
      </UserStorage>
    </BrowserRouter>
  );
};

export default App;
